<template>
    <GlobalFooter class="i-copyright" :links="links" />
</template>
<script>
    export default {
        name: 'i-copyright',
        data () {
            return {
                links: [
                    {
                    key: "Copyright © 2024    智税通数字平台",
                    title: "Copyright © 2024    智税通数字平台",
                    blankTarget: true,
                    },
                    {
                    key: "ZCED&DOSION 提供云原生技术支持",
                    title: "ZCED&DOSION 提供云原生技术支持",
                    blankTarget: true,
                    },
                    {
                    key: "津ICP备2024016893号 津公网安备 12022302000787号",
                    title: "津ICP备2024016893号 津公网安备 12022302000787号",
                    href: "https://beian.miit.gov.cn/",
                    blankTarget: true,
                    },
                ],
            }
        },
        mounted(){
            this.$nextTick(()=>{
                const a = [...document.querySelectorAll(".ivu-global-footer div a")];
                a.forEach((v)=>{
                    if(v.innerText.indexOf("津公网安备") != -1){
                    console.log();
                    v.innerHTML = v.innerText.replace("津公网安备"," <img src='images/bei.png' style='vertical-align: bottom;margin:0px 3px 0px 5px'/>津公网安备")
                    }
                })
            })
        }
    }
</script>
<style lang="less">
    .i-copyright{
        flex: 0 0 auto;
        &-hidden{
            display: none;
        }
    }
</style>
